import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩国漫画在线阅读`}
          title={`${comic.title} - 免费漫画阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2">
          <span
            className={`px-2 py-0.5 text-xs rounded-full whitespace-nowrap ${
              comic.status === 'completed'
                ? 'bg-secondary-100 text-secondary-700'
                : 'bg-primary-100 text-primary-700'
            }`}
          >
            {comic.status === 'completed' ? '已完结' : '连载中'}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
          <div className="flex items-center gap-2 text-white/90 text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-400 w-3 h-3 flex items-center justify-center"></i>
              {comic.rating}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
              {(comic.views / 10000).toFixed(1)}万
            </span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
          {comic.author} · 共{comic.totalChapters}话
        </p>
      </div>
    </Link>
  );
}